import { render, staticRenderFns } from "./SizePicker.vue?vue&type=template&id=775a61b6"
import script from "./SizePicker.vue?vue&type=script&lang=js"
export * from "./SizePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports